import { render, staticRenderFns } from "./PointRecordDialog.vue?vue&type=template&id=e268880e&scoped=true&"
import script from "./PointRecordDialog.vue?vue&type=script&lang=js&"
export * from "./PointRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e268880e",
  null
  
)

export default component.exports